import React from 'react';

function ButtonPlusComp(props) {
  const key = props.key
  const isClicked = props.isClicked;
  return (
    <div className='flex flex-row gap-2 p-2'>
      <button
        className='bg-green-300 hover:bg-green-400 text-gray-800 font-bold px-1.5 rounded inline-flex items-center w-7 h-7'
        onClick={props.click}
      >
        <span className='m-auto'>{isClicked ? '-' : '+'}</span>
      </button>
      <span>{props.title}</span>
    </div>
  );
}

export default ButtonPlusComp;
